import React from 'react';
import { Film } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-gray-800">
      <div className="container mx-auto px-6 py-12">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Brand Section */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <Film className="w-8 h-8 text-amber-500" />
              <span className="font-bold text-xl tracking-wider text-amber-500">
                khalilmohammad.dev
              </span>
            </div>
            {/* <p className="text-gray-400 leading-relaxed">
              Where technology meets storytelling. Creating digital experiences 
              that captivate audiences and solve real-world problems.
            </p> */}
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => document.querySelector('#hero').scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-amber-500 transition-colors duration-300"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.querySelector('#projects').scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-amber-500 transition-colors duration-300"
                >
                  Projects
                </button>
              </li>
              {/* <li>
                <button 
                  onClick={() => document.querySelector('#about').scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-amber-500 transition-colors duration-300"
                >
                  About
                </button>
              </li> */}
              <li>
                <button 
                  onClick={() => document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-amber-500 transition-colors duration-300"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Get in Touch</h4>
            <div className="space-y-2 text-gray-400">
              <p>khalilmohammad.business@gmail.com</p>
              <p>+33 667972677</p>
              <p>CAEN, FRANCE</p>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center space-x-2 text-gray-400 mb-4 md:mb-0">
              <span>© {currentYear} Khalil Mohammad</span>
              
            </div>
            
            {/* <div className="text-gray-400 text-sm">
              <span>Inspired by the magic of cinema</span>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;